import { useNavigate, useSearchParams } from "react-router-dom"
import Container from "../../../components/Container"
import { Button, Grid2, Typography } from "@mui/material"
import { Cancel, CheckCircle } from "@mui/icons-material"
import { useApp } from "../../../contexts/AppContext"

export default function PaymentStatus() {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const {translate} = useApp()

    const status = searchParams.get('status')
    const order_id = searchParams.get('orderId')

    return (
        <Container container flexDirection={'column'} alignItems={'center'} paddingTop={10} gap={5}>
            <Grid2 container gap={1} flexDirection={'column'} alignItems={'center'}>
                <Grid2>
                    {status === 'A' ? <CheckCircle color="success" sx={{ fontSize: 72 }} /> : <Cancel color="error" sx={{ fontSize: 72 }} />}
                </Grid2>
                <Grid2>
                    <Typography fontWeight={'bold'} variant="h5">
                        {status === 'A' ? translate('Payment Success') : translate('Payment Failed')}
                    </Typography>
                </Grid2>
            </Grid2>
            <Grid2 container gap={1}>
                <Grid2>
                    <Button onClick={() => navigate('/dashboard/orders/manage?order_id=' + order_id)} variant="contained">{translate("View Order")}</Button>
                </Grid2>
                <Grid2>
                    <Button onClick={() => navigate('/')} variant="outlined">{translate("Return Home")}</Button>
                </Grid2>
            </Grid2>
        </Container>
    )
}